import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=0712dbe5&scoped=true&lang=pug"
import script from "./Slides.vue?vue&type=script&lang=ts"
export * from "./Slides.vue?vue&type=script&lang=ts"
import style0 from "./Slides.vue?vue&type=style&index=0&id=0712dbe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712dbe5",
  null
  
)

export default component.exports